import React from "react";
import { useTranslation } from "react-i18next";

import { deleteAccount, DeleteAccountPayload } from "@admin/api/account";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

export const useDeleteAccount = () => {
    const [isLoading, setIsLoading] = React.useState(false);

    const { t } = useTranslation(["pages"]);

    const onMutate = (payload: DeleteAccountPayload, onSuccess: () => void) => {
        setIsLoading(true);

        void deleteAccount(payload)
            .then(() => {
                showSuccessToast(t("pages:adminAccountsPage.toast.accountDeleted"));
                onSuccess();
            })
            .catch((error: Error) => {
                showErrorToast(error.message || t("pages:adminAccountsPage.toast.accountDeletedError"));
            })
            .finally(() => setIsLoading(false));
    };

    return { isLoading, onMutate };
};
